import moment from '@narvar/moment-shim';

import {
  RECEIVE_IS_FETCHING_LOCAL_PICKUP_STATE,
  RECEIVE_LOCAL_PICKUP_TIMES,
  RECEIVE_LOCAL_PICKUP_INSTRUCTIONS,
  SELECT_TIMESLOT,
  RECEIVE_TOGGLE_LOCAL_PICKUP_INSTRUCTIONS,
  RECEIVE_LOCAL_PICKUP_ERROR,
} from '../../actions/localPickup';
import { SELECT_RETURN_OPTION } from '../../actions/returnOptions';

export const initialState = {
  isFetching: false,
  isError: false,
  instructions: '',
  showInstructions: false,
  date: '',
  timeslots: [],
  slotId: null,
  selectedTimeslot: {
    value: '',
    label: '',
  },
  dateDisplay: {
    longDate: '',
    shortDate: '',
  },
};

export default (
  state = initialState,
  { type, data: { isFetching, date, timeslots, slotId, instructions, selectedTimeslot } = {} } = {},
) => {
  switch (type) {
    case RECEIVE_TOGGLE_LOCAL_PICKUP_INSTRUCTIONS:
      return {
        ...state,
        showInstructions: !state.showInstructions,
        instructions: '',
      };

    case RECEIVE_IS_FETCHING_LOCAL_PICKUP_STATE:
      return {
        ...state,
        isFetching,
        isError: false,
      };

    case RECEIVE_LOCAL_PICKUP_TIMES: {
      const momentDate = moment(date);
      const shortDate = momentDate.format('MMMM D');
      const isAvailableTomorrow = moment().isSame(momentDate.subtract(1, 'day'), 'day');

      return {
        ...state,
        date,
        timeslots,
        slotId,
        dateDisplay: {
          longDate: momentDate.format('dddd, MMMM D,'),
          shortDate: isAvailableTomorrow ? `Tomorrow, ${shortDate}` : `${shortDate}`,
        },
      };
    }

    case RECEIVE_LOCAL_PICKUP_ERROR:
      return {
        ...state,
        isError: true,
      };

    case RECEIVE_LOCAL_PICKUP_INSTRUCTIONS:
      return {
        ...state,
        instructions,
      };

    case SELECT_TIMESLOT:
      return {
        ...state,
        selectedTimeslot,
      };

    case SELECT_RETURN_OPTION:
      return {
        ...state,
        selectedTimeslot: initialState.selectedTimeslot,
      };

    default:
      return state;
  }
};
